/**
 * Billing API client — endpoints du système de crédits Life
 * (cf. spec "Life — Adaptation du système d'offres", §3.4).
 *
 * Toutes les fonctions renvoient directement la `response` axios (donc
 * `response.data` côté caller), pour rester cohérent avec le reste du repo
 * (cf. utils/api.js : `makeGetRequest` etc.).
 */
import {
  makeGetRequest,
  makePostRequest,
} from '../../utils/api'

const SUB_BASE = '/api/subscription'

// GET /api/subscription/billing/wallet/
export function fetchWallet() {
  return makeGetRequest(`${SUB_BASE}/billing/wallet/`, undefined, true)
}

// GET /api/subscription/billing/packs/
export function fetchPacks() {
  return makeGetRequest(`${SUB_BASE}/billing/packs/`, undefined, true)
}

// POST /api/subscription/billing/packs/<code>/checkout/
//   → renvoie { checkout_url, session_id }
export function createPackCheckout(packCode) {
  return makePostRequest(
    `${SUB_BASE}/billing/packs/${encodeURIComponent(packCode)}/checkout/`,
    {},
    undefined,
    true,
  )
}

// GET /api/subscription/billing/usage/estimate/?feature=...&tier=...
//   → renvoie { feature, tier, cost, wallet_total, sufficient }
export function estimateCost({ feature, tier, baseCost } = {}) {
  const params = new URLSearchParams()
  if (feature) params.set('feature', feature)
  if (tier) params.set('tier', tier)
  if (baseCost != null) params.set('base_cost', String(baseCost))
  return makeGetRequest(
    `${SUB_BASE}/billing/usage/estimate/?${params.toString()}`,
    undefined,
    true,
  )
}

// GET /api/subscription/user-plan/  (déjà existant — réutilisé ici pour
// peupler la partie "abonnement" du BillingDashboard).
export function fetchUserPlan() {
  return makeGetRequest(`${SUB_BASE}/user-plan/`, undefined, true)
}

// POST /api/subscription/portal-session/ — pour rediriger l'utilisateur
// vers le Customer Portal Stripe (gestion CB, annulation, factures).
export function createPortalSession() {
  return makePostRequest(`${SUB_BASE}/portal-session/`, {}, undefined, true)
}
